import { atomEmptyNull } from 'utils/atomUtils';
import { User } from 'swagger/models';

export const incompleteUserDataAtom = atomEmptyNull<User>();
